module.exports = __webpack_public_path__ + "static/media/1040349.cbaf36aa.jpg";